import { createClient } from '@supabase/supabase-js'

// Single Supabase client instance for the entire application
// This prevents "Multiple GoTrueClient instances detected" warnings
// Using localStorage for auth persistence (default behavior)
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL || 'your-supabase-url',
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'your-supabase-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined
    }
  }
)
